import React, { useEffect, useState, useRef } from 'react'
import { Button, Col, Container, Form, Modal, Row, Spinner, Table, Tab, Nav } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import Pagination from '../Common/Pagination';
import FileViewer from "../Common/FileViewer";

const JaptiNotice = () => {

  const financialYear = useSelector((state) => state.activeData.financialYear);
  const userState = useSelector(state => state?.loginData?.userData);

  const [zone, setZone] = useState('');
  const [gat, setGat] = useState('');
  const [key, setKey] = useState("withBill");

  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showNotice, setShowNotice] = useState(false);
  const [noticeDetails, setNoticeDetails] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchProperty, setSearchProperty] = useState("");
  const [searchPropErr, setSearchPropErr] = useState(false);

  const [zoneList, setZoneList] = useState([]);
  const [allGatList, setAllGatList] = useState([]);
  const [filterGat, setFilterGat] = useState([]);
  const [japtiPersonList, setJaptiPersonList] = useState([]);
  const [japtiPersonMobile, setJaptiPersonMobile] = useState('');
  const [propertySearchId, setPropertySearchId] = useState('');
  const [isJaptiNotice, setIsJaptiNotice] = useState("");

  // Image preview states
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const [pageNo, setPageNo] = useState(1);
  const [docPerPage, setDocPerPage] = useState(10);
  const [noOfPages, setNoOfPages] = useState(0);

  const requestRef = useRef(0);
  const prevYearRef = useRef(financialYear);

  const handlePageChange = (pageNumber) => { setPageNo(pageNumber); };
  const handleDocsPerPage = (docsPageProp) => { setPageNo(1); setDocPerPage(docsPageProp); };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const handleCloseImageModal = () => {
    setShowImageModal(false);
    setSelectedImage("");
  };

  useEffect(() => {
    getZoneList();
    getGatList();
    getJaptiNoticePersonList();
  }, []);

  useEffect(() => {
    const isYearChanged = prevYearRef.current !== financialYear;

    if (isYearChanged) {
      setZone("");
      setGat("");
      setJaptiPersonMobile("");
      setPropertySearchId("");
      setIsJaptiNotice("");
      setSearchProperty("");
      setStartDate("");
      setEndDate("");
      setPageNo(1);
      setData([]);
      prevYearRef.current = financialYear;
    }

    getJaptiData(
      key,
      isYearChanged ? 1 : pageNo,
      isYearChanged ? "" : zone,
      isYearChanged ? "" : gat,
      isYearChanged ? "" : japtiPersonMobile,
      isYearChanged ? "" : propertySearchId,
      isYearChanged ? "" : isJaptiNotice,
      isYearChanged ? "" : searchProperty,
      isYearChanged ? "" : startDate,
      isYearChanged ? "" : endDate
    );
  }, [key, pageNo, docPerPage, financialYear]);

  useEffect(() => {
    const result = allGatList?.filter((row) => row.zonekey == zone);
    setFilterGat(result);
    setGat("");
  }, [zone]);

  const getZoneList = async () => {
    try {
      const res = await fetch(process.env.REACT_APP_BASE_URL + `/zoneData/getZoneData`, { method: "GET" });
      const response = await res.json();
      setZoneList(response.data);
    } catch (err) {
      console.log("Error While Fetching Zone List", err);
    }
  };

  const getGatList = async () => {
    try {
      const res = await fetch(process.env.REACT_APP_BASE_URL + `/gatData/getGatData`, { method: "POST" });
      const response = await res.json();
      setAllGatList(response.data);
      setFilterGat(response.data);
    } catch (err) {
      console.log("Error While Fetching Gat List", err);
    }
  };

  const getJaptiNoticePersonList = async () => {
    try {
      const res = await fetch(process.env.REACT_APP_BASE_URL + `/japtinotice/getJaptiNoticePerson`, { method: "GET" });
      const response = await res.json();
      setJaptiPersonList(response);
    } catch (err) {
      console.log("Error While Notice Persons List", err);
    }
  };

  const getJaptiData = async (
    activeKey = key,
    pNo = pageNo,
    zoneVal = zone,
    gatVal = gat,
    japtiMobile = japtiPersonMobile,
    propSearchId = propertySearchId,
    japtiNotice = isJaptiNotice,
    searchProp = searchProperty,
    sDate = startDate,
    eDate = endDate
  ) => {
    const requestId = ++requestRef.current;
    setLoader(true);
    setData([]);

    let url = "";
    let payload = {};

    if (activeKey === "withBill") {
      url = process.env.REACT_APP_BASE_URL + "/billDistribution/getBillDistributionsNoticeCount";
      payload = {
        propertyCode: searchProp,
        gatkey: gatVal ? gatVal : "",
        zonekey: zoneVal ? zoneVal : "",
        visitingPersonContactNo: "",
        documentsPerPage: docPerPage,
        page: pNo,
        zoneno: "",
        japtiPersonMobile: japtiMobile,
        financialYear: financialYear,
        ...(userState?.usertype_keyname?.includes("zonalofficer") && {
          zonekey: userState?.zonekey
        }),
        fromDate: sDate,
        toDate: eDate,
        isJaptiNotice: japtiNotice,
        propertySearchId: propSearchId,
      };
    } else if (activeKey === "separate") {
      url = process.env.REACT_APP_BASE_URL + "/japtinotice/getAllJaptiNoticeWithPagination";
      payload = {
        propertyCode: searchProp,
        zonekey: zoneVal,
        gatkey: gatVal,
        japtiPersonMobile: japtiMobile,
        fromDate: sDate,
        toDate: eDate,
        isJaptiNotice: japtiNotice,
        documentsPerPage: docPerPage,
        page: pNo,
        financialYear: financialYear,
      };
    }

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const response = await res.json();

      if (requestId !== requestRef.current) return;

      setData(response);
      setNoOfPages(response.noOfPages || 0);
    } catch (err) {
      if (requestId === requestRef.current) {
        console.log("Error while getting Japti data", err);
        setData([]);
      }
    } finally {
      if (requestId === requestRef.current) {
        setLoader(false);
      }
    }
  };

  const handleSearch = () => {
    setPageNo(1);
    getJaptiData(key, 1);
  };

  // Date range validation - JaptiKarvai jaisa
  const getSearchbyDates = () => {
    if (startDate && endDate) {
      setPageNo(1);
      getJaptiData(key, 1);
    } else {
      toast.error("Please Select both Start and End Date");
    }
  };

  // Property code search - JaptiKarvai jaisa
  const searchByProperty = () => {
    if (searchProperty.length > 0) {
      setSearchPropErr(false);
      setPageNo(1);
      getJaptiData(key, 1);
    } else {
      setSearchPropErr(true);
    }
  };

  return (
    <div className='JaptiKarvai distribution'>
      <ToastContainer />
      <Container>

        <div className='d-flex justify-content-center align-items-center mb-4'>
          <Icon.CardHeading className='me-2' size={22} color='#073c7c' />
          <h5 className='p-0 text-center mb-0'>Japti Notice</h5>
        </div>

        {/* Search by Zone/Gat */}
        <Row className="justify-content-center mb-4">
          <Col md={5} className="searchCard justify-content-center">
            <div className="label mb-2 mx-auto"><p>Search by Zone/Gat</p></div>
            <Row className="parentRow d-flex justify-content-center">
              <Col md={4} className="mb-3 mb-md-0">
                <Form.Select value={zone} onChange={(e) => setZone(e.target.value)}>
                  <option value="" disabled>Select Zone</option>
                  {zoneList !== undefined && zoneList.length > 0 ? (
                    zoneList.map((row) => (
                      <option key={row.zonekey} value={row.zonekey}>
                        {row.zonename + "-" + row.zoneno}
                      </option>
                    ))
                  ) : (
                    <option value="">No Data Found</option>
                  )}
                </Form.Select>
              </Col>

              <Col md={4} className="mb-3 mb-md-0">
                <Form.Select value={gat} onChange={(e) => setGat(e.target.value)}>
                  <option value="" disabled>Select Gat</option>
                  {filterGat !== undefined && filterGat.length > 0 ? (
                    filterGat.map((row) => (
                      <option key={row?.gatkey} value={row?.gatkey}>
                        {row.mar_gatname + '-' + row.gatname}
                      </option>
                    ))
                  ) : (
                    <option value="">No Data Found</option>
                  )}
                </Form.Select>
              </Col>

              <Col md={2} className="d-flex justify-content-md-start justify-content-center">
                <Button className="btn btn-submit" onClick={handleSearch}>
                  <Icon.Search className="me-2" size={14} />Search
                </Button>
              </Col>
            </Row>
          </Col>

          {/*  Date Range Filter - JaptiKarvai jaisa */}
          <Col md={5} className="searchCard justify-content-center ms-0 ms-md-4">
            <div className="label mb-2 mx-auto"><p>Search by Date</p></div>
            <Row>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className="me-3">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) => {
                      setStartDate(moment(e.target.value).format("YYYY-MM-DD"));
                      setEndDate("");
                    }}
                  />
                </div>
                <div className="me-3">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    min={startDate ? startDate : ""}
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      setEndDate(moment(e.target.value).format("YYYY-MM-DD"))
                    }
                  />
                </div>
                <div className="d-flex justify-content-center align-items-end">
                  <Button className="btn btn-submit" onClick={getSearchbyDates} style={{ height: 40 }}>
                    <Icon.Search className="me-2" size={14} />Search
                  </Button>
                </div>
              </div>
            </Row>
          </Col>
        </Row>

        <Row className='justify-content-center'>
          {/*  Property Code Filter - JaptiKarvai jaisa */}
          <Col md={4} className="searchCard justify-content-center mb-4">
            <div className="label mb-2 mx-auto"><p>Search by Property Code</p></div>
            <div className="d-flex mt-1">
              <Form.Control
                placeholder="Property Code"
                value={searchProperty}
                onChange={(e) => {
                  if (/^[0-9]*\.?[0-9]*$/.test(e.target.value)) {
                    setSearchProperty(e.target.value);
                    setSearchPropErr(false);
                  }
                }}
              />
              <Button className="btn-submit ms-3" onClick={searchByProperty}>
                <Icon.Search className="me-2" size={14} />Search
              </Button>
            </div>
            {searchPropErr ? <p className="errMsg">Please enter valid property code</p> : null}
          </Col>

          {/* --------- Commented Filters --------- */}

          {/* <Col md={4} className="searchCard justify-content-center mb-4 ms-0 ms-md-4">
            <div className="label mb-2 mx-auto"><p>Search by Japti Person</p></div>
            <Row>
              <Col md={8}>
                <Form.Select value={japtiPersonMobile} onChange={(e) => setJaptiPersonMobile(e.target.value)}>
                  <option value="" disabled>Select any japti person</option>
                  {japtiPersonList?.japtiPersons !== undefined && japtiPersonList.japtiPersons?.length > 0 ? (
                    japtiPersonList.japtiPersons?.map((row) => (
                      <option key={row?.japtiPersonMobile} value={row?.japtiPersonMobile}>
                        {row.japtiPersonName}
                      </option>
                    ))
                  ) : (
                    <option value="">No Data Found</option>
                  )}
                </Form.Select>
              </Col>
              <Col md={2} className="d-flex justify-content-md-start justify-content-center">
                <Button className="btn btn-submit" onClick={handleSearch}>
                  <Icon.Search className="me-2" size={14} />Search
                </Button>
              </Col>
            </Row>
          </Col> */}

          {/* <Col md={4} className="searchCard justify-content-center mb-4">
            <div className="label mb-2 mx-auto"><p>Search by Property Search Person</p></div>
            <Row>
              <Col md={8}>
                <Form.Select value={propertySearchId} onChange={(e) => setPropertySearchId(e.target.value)}>
                  <option value="" disabled>Select Property Search Person</option>
                  {japtiPersonList?.propertySearchPersons !== undefined && japtiPersonList.propertySearchPersons?.length > 0 ? (
                    japtiPersonList.propertySearchPersons?.map((row) => (
                      <option key={row?.propertySearchId} value={row?.propertySearchId}>
                        {row?.propertySearchName + '-' + row?.propertySearchMobile}
                      </option>
                    ))
                  ) : (
                    <option value="">No Data Found</option>
                  )}
                </Form.Select>
              </Col>
              <Col md={2} className="d-flex justify-content-md-start justify-content-center">
                <Button className="btn btn-submit" onClick={handleSearch}>
                  <Icon.Search className="me-2" size={14} />Search
                </Button>
              </Col>
            </Row>
          </Col> */}

          {/* <Col md={4} className="searchCard justify-content-center mb-4 ms-0 ms-md-4">
            <div className="label mb-2 mx-auto"><p>Search by Notice Status</p></div>
            <Row>
              <Col md={8}>
                <Form.Select value={isJaptiNotice} onChange={(e) => setIsJaptiNotice(e.target.value)}>
                  <option value="" disabled>Select Notice Status</option>
                  <option value={true}>Japti notice given</option>
                  <option value={false}>Japti property searched</option>
                </Form.Select>
              </Col>
              <Col md={2} className="d-flex justify-content-md-start justify-content-center">
                <Button className="btn btn-submit" onClick={handleSearch}>
                  <Icon.Search className="me-2" size={14} />Search
                </Button>
              </Col>
            </Row>
          </Col> */}

        </Row>

        <Row className="d-flex justify-content-between align-items-center mb-3">
          <Col md={6}>
            <Tab.Container activeKey={key} onSelect={(k) => {
              setKey(k);
              setZone("");
              setGat("");
              setJaptiPersonMobile("");
              setPropertySearchId("");
              setIsJaptiNotice("");
              setSearchProperty("");
              setStartDate("");
              setEndDate("");
              setPageNo(1);
              setData([]);
            }}>
              <Nav variant="pills" className="flex-row">
                <Nav.Item>
                  <Nav.Link eventKey="withBill">Notice Distributed with Bill</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="separate">Notice Distributed Separately</Nav.Link>
                </Nav.Item>
              </Nav>
            </Tab.Container>
          </Col>

          <Col md={6} className="text-end">
            <h5 className="mb-0">
              Total count - {key === "withBill" ? data?.count || 0 : data?.totalCount || 0}
            </h5>
          </Col>
        </Row>

        <Row>
          <div className="container tbl-container p-0">
            <div className="row tbl-fixed p-0" style={{ maxHeight: '65vh' }}>
              <Table responsive="lg" hover>
                <thead>
                  <tr>
                    <th>Sr</th>
                    <th>Property Code</th>
                    <th>Property Name</th>
                    <th>Zone</th>
                    <th>Gat</th>
                    <th>Visit Date</th>
                    <th>Notice Date</th>
                    <th>Property Search Person</th>
                    <th>Japti Person</th>
                    <th>Created By</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan="11" className="text-center">
                        <Spinner variant="primary" className="mt-2" />
                      </td>
                    </tr>
                  ) : data?.data !== null && data?.data !== undefined && data?.data.length > 0 ? (
                    data?.data.map((row, index) => (
                      <tr key={index} style={{ textAlign: "center", cursor: "pointer" }}>
                        <td>{pageNo !== 1 ? index + 1 + docPerPage * (pageNo - 1) : index + 1}</td>
                        <td>{row?.propertyCode}</td>
                        <td>{row?.propertyName}</td>
                        <td>{row?.zonename}</td>
                        <td>{row?.gatname?.toString()}</td>
                        <td>{row?.visitDate ? moment(row?.visitDate).format("DD-MM-YYYY") : '-'}</td>
                        <td>{row?.japtiNoticeDate ? moment(row?.japtiNoticeDate).format("DD-MM-YYYY") : '-'}</td>
                        <td>{row?.propertySearchName ? row?.propertySearchName + `${row?.propertySearchMobile ? `(` + row?.propertySearchMobile + `)` : ''}` : '-'}</td>
                        <td>{row?.japtiPersonName ? row?.japtiPersonName + ` ${row?.japtiPersonMobile ? `(` + row?.japtiPersonMobile + `)` : ''}` : '-'}</td>
                        <td>{row?.createdByName ? row?.createdByName + `${row?.createdByMobile ? `(` + row?.createdByMobile + `)` : ''}` : '-'}</td>
                        <td>
                          <Icon.Eye size={20} onClick={() => { setNoticeDetails(row); setShowNotice(true); }} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center">No Data Found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            <Row>
              <Col md={4} className="d-flex align-items-center mt-3 mt-md-0">
                <h6 className="text-start mb-0">
                  <Icon.People className="me-2" />
                  Total - <strong>{key === "withBill" ? data?.count || 0 : data?.totalCount || 0}</strong>
                </h6>
              </Col>
              <Col md={8} className="d-flex justify-content-end">
                <Pagination
                  currentPage={pageNo}
                  totalPages={noOfPages}
                  onPageChange={handlePageChange}
                  onDocsPerPage={handleDocsPerPage}
                  docsPerPage={docPerPage}
                />
              </Col>
            </Row>
          </div>
        </Row>

        {/* --------- Japti Details View Modal --------- */}
        <Modal dialogClassName="modal" show={showNotice} onHide={() => setShowNotice(false)} centered backdrop="static" keyboard={false} size="lg">
          <Modal.Header closeButton>
            <Modal.Title className="d-flex align-items-center">
              <Icon.Coin className='me-2' />
              <h5 className="mb-0">View Japti Notice Details</h5>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row>
              <Col md={6}>
                <div className='data'>
                  <h6>{noticeDetails?.isJaptiNotice ? <Icon.ToggleOn className='me-2' size={16} /> : <Icon.ToggleOff className='me-2' size={16} />}Notice Status : </h6>
                  <p>{noticeDetails?.isJaptiNotice ? <Icon.CheckCircleFill color='green' /> : <Icon.XCircleFill color='red' />}</p>
                </div>

                <div className='data'>
                  <h6><Icon.ClockFill className='me-2' />Japti Date : </h6>
                  <p>{noticeDetails?.japtiDate ? moment(noticeDetails?.japtiDate).format("YYYY-MM-DD") : '-'}</p>
                </div>

                <div className='data'>
                  <h6><Icon.ClockFill className='me-2' />Japti Notice Date : </h6>
                  <p>{noticeDetails?.japtiNoticeDate ? moment(noticeDetails?.japtiNoticeDate).format("YYYY-MM-DD") : '-'}</p>
                </div>

                <div className='data'>
                  <h6><Icon.PersonFill className='me-2' />Japti Given By : </h6>
                  <p>{noticeDetails?.japtiPersonName ? noticeDetails?.japtiPersonName : '-' + ` ${noticeDetails?.japtiPersonMobile ? `(` + noticeDetails?.japtiPersonMobile + `)` : ''}`}</p>
                </div>

                <div className='data'>
                  <h6><Icon.PersonFill className='me-2' />Visited By : </h6>
                  <p>{noticeDetails?.createdByName ? noticeDetails?.createdByName : '-' + ` ${noticeDetails?.createdByMobile ? `(` + noticeDetails?.createdByMobile + `)` : ''}`}</p>
                </div>
              </Col>

              <Col md={6}>
                <div className='data'>
                  <h6><Icon.BuildingFill className='me-2' />Property Code :</h6>
                  <p>{noticeDetails?.propertyCode}</p>
                </div>

                <div className='data'>
                  <h6><Icon.PersonFill className='me-2' />Property Name :</h6>
                  <p>{noticeDetails?.propertyName}</p>
                </div>

                <div className='data'>
                  <h6><Icon.PersonFill className='me-2' />Meeting Person :</h6>
                  <p>{noticeDetails?.meetingPersonName + `(${noticeDetails?.meetingPersonContactNo})`}</p>
                </div>

                <div className='data'>
                  <h6><Icon.GeoFill className='me-2' />Zone :</h6>
                  <p>{noticeDetails?.zonename}</p>
                </div>

                <div className='data'>
                  <h6><Icon.GeoFill className='me-2' />Gat :</h6>
                  <p>{noticeDetails?.gatname}</p>
                </div>
              </Col>
            </Row>

            <Row>
              <div className='data'>
                <h6><Icon.BuildingFill className='me-2' />Udyog Karta Shulk :</h6>
                <p>{noticeDetails?.upayogakartaShulkName ? noticeDetails?.upayogakartaShulkName : '-'}</p>
              </div>

              <div className='data'>
                <h6><Icon.GeoAltFill className='me-2' />Address :</h6>
                <p>{noticeDetails?.propertyAddress}</p>
              </div>

              <div className='data'>
                <h6><Icon.GeoAltFill className='me-2' />Updated Address :</h6>
                <p>{noticeDetails?.addressUpdated}</p>
              </div>

              {/* ✅ Image Preview - FileViewer pattern */}
              <Row className='d-flex mt-3'>
                {noticeDetails?.propertyImg?.length > 0 &&
                  <Col md={3}>
                    <h6><Icon.ImageFill className='me-2' color='#073c7c' />Property Image</h6>
                    <div className='ms-2'>
                      <img
                        src={noticeDetails?.propertyImg}
                        alt="Property"
                        width={80}
                        height={80}
                        style={{ objectFit: "cover", borderRadius: "4px", cursor: "pointer" }}
                        onClick={() => handleImageClick(noticeDetails?.propertyImg)}
                        onError={(e) => { e.target.src = "https://cdn-icons-png.flaticon.com/512/972/972601.png"; }}
                      />
                    </div>
                  </Col>
                }

                {noticeDetails?.japtiNoticeDocumentImage?.length > 0 &&
                  <Col md={3}>
                    <h6><Icon.ImageFill className='me-2' color='#073c7c' />Notice Document</h6>
                    <div className='ms-2'>
                      <img
                        src={noticeDetails?.japtiNoticeDocumentImage}
                        alt="Notice Document"
                        width={80}
                        height={80}
                        style={{ objectFit: "cover", borderRadius: "4px", cursor: "pointer" }}
                        onClick={() => handleImageClick(noticeDetails?.japtiNoticeDocumentImage)}
                        onError={(e) => { e.target.src = "https://cdn-icons-png.flaticon.com/512/972/972601.png"; }}
                      />
                    </div>
                  </Col>
                }

                {noticeDetails?.japtiNoticeImage?.length > 0 &&
                  <Col md={3}>
                    <h6><Icon.ImageFill className='me-2' color='#073c7c' />Notice Image</h6>
                    <div className='ms-2'>
                      <img
                        src={noticeDetails?.japtiNoticeImage}
                        alt="Notice Image"
                        width={80}
                        height={80}
                        style={{ objectFit: "cover", borderRadius: "4px", cursor: "pointer" }}
                        onClick={() => handleImageClick(noticeDetails?.japtiNoticeImage)}
                        onError={(e) => { e.target.src = "https://cdn-icons-png.flaticon.com/512/972/972601.png"; }}
                      />
                    </div>
                  </Col>
                }
              </Row>
            </Row>
          </Modal.Body>
        </Modal>

        {/* ✅ FileViewer */}
        {showImageModal && (
          <FileViewer
            file={selectedImage}
            onClose={handleCloseImageModal}
          />
        )}

      </Container>
    </div>
  );
};

export default JaptiNotice;